export type FaqAlias = "renter" | "procedures";

const FAQ_ALIAS_PATHS: Record<FaqAlias, string> = {
  renter: "/faq/renter",
  procedures: "/faq/procedures",
};

const FAQ_CANONICAL_PATHS: Record<FaqAlias, string> = {
  renter: "/faq-renter",
  procedures: "/faq-procedures",
};

/** Resolve either the nested compatibility alias or its primary source path. */
export function resolveFaqFamily(pathname: string): FaqAlias | null {
  for (const alias of Object.keys(FAQ_ALIAS_PATHS) as FaqAlias[]) {
    const nested = FAQ_ALIAS_PATHS[alias];
    const canonical = FAQ_CANONICAL_PATHS[alias];
    if (
      pathname === nested || pathname === `${nested}/` ||
      pathname === canonical || pathname === `${canonical}/`
    ) return alias;
  }
  return null;
}

/** Match only the reviewed, case-sensitive legacy aliases. */
export function resolveFaqAlias(pathname: string): FaqAlias | null {
  const alias = resolveFaqFamily(pathname);
  return alias && (pathname === FAQ_ALIAS_PATHS[alias] || pathname === `${FAQ_ALIAS_PATHS[alias]}/`)
    ? alias
    : null;
}

export function faqAliasCanonicalPath(alias: FaqAlias): string {
  return FAQ_CANONICAL_PATHS[alias];
}

export function faqAliasNonMainHostTarget(alias: FaqAlias, search = ""): string {
  const target = alias === "renter" ? "/help" : "/help/topic/booking-a-car";
  return `${target}${search}`;
}